import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import ThresholdValues from "./ThresholdValues";
import "./inventory.scss";
import InventoryHistory from "./InventoryHistory";
import AvailableInventory from "./AvailableInventory";
import IssuedInventory from "./IssuedInventory";
import ReturnedInventory from "./ReturnedInventory";
import DiscardedInventory from "./DiscardedInventory";
import NeedRepairInventory from "./NeedRepairInventory";
import InventoryHandover from "./InventoryHandover";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: theme.palette.background.paper,
  },
}));
const Inventory = () => {
  // ----------------for tab-------------------
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Sidebar>
      <Grid container className="inventory_wrapper">
        <Grid item xs={12}>
          {/* -------------------Tab Area---------- */}
          <Grid className={classes.root}>
            <Grid className="ml">
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="Threshold Values" {...a11yProps(0)} />
                <Tab label="Purchased Inventory History" {...a11yProps(1)} />
                <Tab label="Available Inventory" {...a11yProps(2)} />
                <Tab label="Issued Inventory History" {...a11yProps(3)} />
                <Tab label="Return Inventory History" {...a11yProps(4)} />
                <Tab label="Discarded Inventory " {...a11yProps(5)} />
                <Tab label="Need Repair Inventory " {...a11yProps(6)} />
                <Tab label="Inventory Handover" {...a11yProps(7)} />
              </Tabs>
              <TabPanel value={value} index={0}>
                <Grid container className="">
                  <ThresholdValues />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Grid container className="">
                  <InventoryHistory />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Grid container className="">
                  <AvailableInventory />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Grid container className="">
                  <IssuedInventory />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={4}>
                <Grid container className="">
                  <ReturnedInventory />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={5}>
                <Grid container className="">
                  <DiscardedInventory />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={6}>
                <Grid container className="">
                  <NeedRepairInventory />
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={7}>
                <Grid container className="">
                  <InventoryHandover />
                </Grid>
              </TabPanel>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Sidebar>
  );
};

export default Inventory;
